var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1018_5527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9197 17.1998H27.2041C22.2113 17.1998 18.1641 21.2472 18.1641 26.2398V31.9555C26.044 31.3712 32.3354 25.0797 32.9197 17.1998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7635 31.9555V26.2398C15.7635 21.2472 11.7162 17.1998 6.72349 17.1998H1.00781C1.59208 25.0797 7.88357 31.3712 15.7635 31.9555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9197 14.7998C32.3354 6.91988 26.044 0.628396 18.1641 0.0441284V5.7598C18.1641 10.7525 22.2113 14.7998 27.2041 14.7998H32.9197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7635 0.0441284C7.88357 0.628396 1.59208 6.91988 1.00781 14.7998H6.72349C11.7162 14.7998 15.7635 10.7525 15.7635 5.7598V0.0441284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8281 15.9998C14.0461 14.8916 15.8537 13.084 16.9619 10.866C18.0701 13.084 19.8776 14.8916 22.0957 15.9998C19.8776 17.108 18.0701 18.9156 16.9619 21.1336C15.8537 18.9156 14.0461 17.108 11.8281 15.9998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1018_5527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.960938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo5);
export default __webpack_public_path__ + "static/media/logo-5.e9851c31b52edb1a899e5cea044fe9c6.svg";
export { ForwardRef as ReactComponent };